import { type FC } from 'react';
import {
  PaperPlaneTilt
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconPaperPlaneTiltProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconPaperPlaneTilt: FC<UiIconPaperPlaneTiltProps> = (props) => {
  return (
    <UiIcon
      IconComponent={PaperPlaneTilt}
      {...props}
    />
  );
};
